module.exports = __webpack_public_path__ + "static/media/in_process_icn.6e3c063b.png";